import constants from '@/constants';
import { axiosRequest, METHOD } from '@/api/default.js';

export async function getSearchQueryAnalytics(params) {
    return await axiosRequest({
        url: constants.URL.SEARCH_QUERY_ANALYTICS,
        method: METHOD.GET,
        requestName: 'GET SEARCH QUERY ANALYTICS',
        params,
        isLoader: false,
    });
}
